import { Money } from "@hubrise/react-components"

import { SkuId } from "../ids"
import { ICatalog, IDeal } from "../models"

import ItemDealLine from "./ItemDealLine"

class ItemDeal {
  private readonly catalog: ICatalog
  private readonly deal: IDeal
  private readonly itemDealLines: Array<ItemDealLine>

  constructor(catalog: ICatalog, deal: IDeal) {
    this.catalog = catalog
    this.deal = deal
    this.itemDealLines = deal.lines.map((_, index) => new ItemDealLine(catalog, deal, index))
  }

  get dealLines(): Array<ItemDealLine> {
    return this.itemDealLines
  }

  price(variantRef: string | null): Money {
    return this.itemDealLines.reduce((sum, itemDealLine) => sum.plus(itemDealLine.price(variantRef)), this.nullMoney)
  }

  setSkuId(dealLineIndex: number, skuId: SkuId) {
    this.itemDealLines[dealLineIndex].setSkuId(skuId)
  }

  private get nullMoney(): Money {
    return Money.zero(this.catalog.currency)
  }
}

export default ItemDeal
